import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ChangeOrderModel } from 'src/app/models/api/change-order.model';

@Injectable({
    providedIn: 'root'
})
export class RequestBuilderApiClient {

    private ControllerEndpoint(requestGuid: string) {
        return "/request-builder/" + requestGuid;
    }


    constructor(private httpClient: HttpClient) { }

    changeDocumentOrder(requestGuid: string, indexedDocuments: ChangeOrderModel[]) {
        return this.httpClient.post(environment.apiUrl + this.ControllerEndpoint(requestGuid) + "/ChangeDocumentOrder", indexedDocuments);
    }

}
